import { useStore } from "react-redux";

import useDynamicCallback from "@mapmycustomers/shared/util/hook/useDynamicCallback";

import { RootState } from "@app/store/rootReducer";

const useSelectorWithArgs = <
  TSelected = unknown,
  TArgs extends readonly unknown[] = readonly unknown[],
>(
  selector: (state: RootState, ...args: TArgs) => TSelected
): ((...args: TArgs) => TSelected) => {
  const store = useStore<RootState>();
  return useDynamicCallback((...args) => {
    return selector(store.getState(), ...args);
  });
};

export default useSelectorWithArgs;
